import { render, staticRenderFns } from "./savedMatch.vue?vue&type=template&id=5390a366&scoped=true"
import script from "./savedMatch.vue?vue&type=script&lang=js"
export * from "./savedMatch.vue?vue&type=script&lang=js"
import style0 from "./savedMatch.vue?vue&type=style&index=0&id=5390a366&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390a366",
  null
  
)

export default component.exports